import React, { useContext, useMemo } from "react";
import SelectionItem from "../../SelectionItem";
import ImgBugelBaseTop from "./images/bugelBaseTop.png";
import ImgBugelBaseBottom from "./images/bugelBaseBottom.png";
import ImgBugelBaseBoth from "./images/bugelBaseBoth.png";
import ImgPlasticBaseTop from "./images/plasticBaseTop.png";
import ImgPlasticBaseBottom from "./images/plasticBaseBottom.png";
import ImgPlasticBaseBoth from "./images/plasticBaseBoth.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const RemovableProstheticsSelect = ({
  selectStep,
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData
  } = useContext(StepContext);
  const types = useMemo(() => {
    let typesList = [{
      type: "bugel",
      key: "bugelBaseTop",
      img: ImgBugelBaseTop,
      name: _t("Протез на верхнюю челюсть"),
      side: "top",
      disabled: false
    }, {
      type: "bugel",
      key: "bugelBaseBottom",
      img: ImgBugelBaseBottom,
      name: _t("Протез на нижнюю челюсть"),
      side: "bottom",
      disabled: false
    }, {
      type: "bugel",
      key: "bugelBaseBoth",
      img: ImgBugelBaseBoth,
      name: _t("Протезы на обе челюсти"),
      side: "both",
      disabled: false
    }, {
      type: "plastic",
      key: "plasticBaseTop",
      img: ImgPlasticBaseTop,
      name: _t("Протез на верхнюю челюсть"),
      side: "top",
      disabled: false
    }, {
      type: "plastic",
      key: "plasticBaseBottom",
      img: ImgPlasticBaseBottom,
      name: _t("Протез на нижнюю челюсть"),
      side: "bottom",
      disabled: false
    }, {
      type: "plastic",
      key: "plasticBaseBoth",
      img: ImgPlasticBaseBoth,
      name: _t("Протезы на обе челюсти"),
      side: "both",
      disabled: false
    }];
    let availableSides = [];

    if (dentalData && dentalData.hasOwnProperty("tooth")) {
      let availableTooth = dentalData.tooth.filter(tooth => tooth.toothElementsActive.some(el => el === "emptyTooth"));
      availableTooth.forEach(el => {
        if (!availableSides.includes(el.position)) {
          availableSides.push(el.position);
        }
      });

      if (availableSides.length === 2) {
        availableSides.push("both");
      }
    }

    let packType = "";

    if (stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase") {
      packType = "bugel";
    } else if (stepId === "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase") {
      packType = "plastic";
    }

    typesList = typesList.filter(el => el.type === packType).map(el => ({ ...el,
      disabled: !availableSides.includes(el.side)
    }));
    return typesList;
  }, [_t, dentalData, stepId]);

  function setStep(key) {
    selectStep(key);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "removableProstheticsSelectSide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "removableProstheticsSelectSide-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    disabled: el.disabled
  }))));
};

export default RemovableProstheticsSelect;